module.exports = __webpack_public_path__ + "static/pergola-1-0e4efca1186d46752f5fe53127e7b028.jpg";